module.exports = __webpack_public_path__ + "static/media/driveSafety.e4f4548d.png";